import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  emailSignInStart,
  googleSignInStart,
  facebookSignInStart,
  googleSignInStartWithRedirect,
} from '../../store/user/user.action';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, selectError } from '../../store/user/user.selector';

import { selectCartItems } from '../../store/cart/cart.selector';

import { addItemToCartFromLogin } from '../../store/cart/cart.action';

import {
  setCartItemsToDatabase,
  getCartItemsFromUserDatabase,
} from '../../utils/firebase/firebase.utils';

import CircularDeterminate from '../Progress/circular-determinate';
import FooterNew from '../Footer/section-footer';
import './login-new.css';

// function Copyright(props) {
//   return (
//     <Typography
//       variant="body2"
//       color="text.secondary"
//       align="center"
//       {...props}
//     >
//       {'Copyright © '}
//       <Link color="inherit" href="/">
//         AHGUIDE
//       </Link>{' '}
//       {new Date().getFullYear()}
//       {'.'}
//     </Typography>
//   );
// }

const theme = createTheme();

export default function LogInNew() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const currentUser = useSelector(selectCurrentUser);

  const errorCode = useSelector(selectError);

  const cartItems = useSelector(selectCartItems);

  const [progress, setProgress] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const getCartItemfromDatabase = async () => {
      const cartItemsFromUser = await getCartItemsFromUserDatabase(
        currentUser.id
      );

      if (cartItems.length > 0 && cartItemsFromUser.length > 0) {
        const databaseCart = [...cartItemsFromUser];
        const matchedCart = [];
        const unMatchedCartItems = cartItems.filter(
          ({ id: id1 }) => !cartItemsFromUser.some(({ id: id2 }) => id1 === id2)
        );

        cartItems.filter((obj1) =>
          cartItemsFromUser.some((obj2) => {
            if (obj1.id === obj2.id) {
              const m = { ...obj2, quantity: obj2.quantity + obj1.quantity };
              // cart.length = 0;
              matchedCart.push(m);
            }
          })
        );

        if (unMatchedCartItems.length === 0) {
          var restCartItem = databaseCart.filter(
            (obj1) => !matchedCart.some((obj2) => obj1.id === obj2.id)
          );
        }

        if (unMatchedCartItems.length === 0) {
          var finalCart = restCartItem.concat(matchedCart);
        } else {
          var finalCart = unMatchedCartItems.concat(matchedCart);
        }

        dispatch(addItemToCartFromLogin(finalCart));
        setCartItemsToDatabase(currentUser.id, finalCart);
      } else if (cartItemsFromUser.length > 0) {
        dispatch(addItemToCartFromLogin(cartItemsFromUser));
      } else {
        setCartItemsToDatabase(currentUser.id, cartItems);
      }
    };
    getCartItemfromDatabase();

    navigate('/');

    if (errorCode) {
      handleError(errorCode);
    }
  }, [currentUser, errorCode]);

  const handleError = (errorCode) => {
    if (errorCode === 'auth/wrong-password') {
      alert('Login Failed! Check your email & password combination');
    } else if (errorCode === 'auth/user-not-found') {
      alert('User not Exist! Please create an account');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setProgress(true);
    const data = new FormData(event.currentTarget);
    dispatch(emailSignInStart(data.get('email'), data.get('password')));
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="l" sx={{ mb: 8 }}>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <h2 className="heading-tertiary">Sign in</h2>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ mt: 1, fontSize: '1.8rem' }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              className="mui-form"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              className="mui-form"
            />
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
            {progress ? (
              <CircularDeterminate />
            ) : (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, padding: '1.2rem', fontSize: '1.8rem' }}
              >
                Sign In
              </Button>
            )}

            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="/signup" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
      </Container>
      <FooterNew />
    </ThemeProvider>
  );
}
